var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sim_success_wrapper"},[_c('div',{staticClass:"sim_success"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$i18nApi.t("simRegistration.success")))]),_vm._v(" "),_c('img',{attrs:{"src":"/img/sim_success.svg","alt":"success"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }